module.exports = __webpack_public_path__ + "img/img1.3600a4c7.svg";